import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { debounceTime, merge } from 'rxjs';
import { Utilities } from '@core/helpers/utilities';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';

/**
 * Reacts to RappresentanteCoopCognome/Nome changes: updates FirmaLegaleRappresentante in Conclusioni
 * and mirrors the values to the SezioneII mirror fields.
 */
export const my_FirmaLegaleListenerHelper = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_RappresentanteCoopCognomeControl = getControl(form, `${formPaths.datiIdentificativi}.my_RappresentanteCoopCognome`);
    const my_RappresentanteCoopNomeControl = getControl(form, `${formPaths.datiIdentificativi}.my_RappresentanteCoopNome`);
    merge(my_RappresentanteCoopCognomeControl.valueChanges, my_RappresentanteCoopNomeControl.valueChanges)
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const my_RappresentanteCoopNome: string = my_RappresentanteCoopNomeControl.value;
            const my_RappresentanteCoopCognome: string = my_RappresentanteCoopCognomeControl.value;
            const my_FirmaLegaleRappresentante = `${my_RappresentanteCoopNome ?? ''} ${my_RappresentanteCoopCognome ?? ''}`;
            getControl(form, 'my_SezioneI__Rilevazione.my_Conclusioni.my_FirmaLegaleRappresentante').patchValue(my_FirmaLegaleRappresentante, { emitEvent: false });

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_FirmaLegaleRappresentante = my_FirmaLegaleRappresentante;
                return myVerbaleClone;
            });
        });
};
